<template>
    <div v-if="$store.state.isModalOpenThree" class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-md modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                          <h1 class="mb-0">Payslip Issue</h1>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                  <div class="row mx-2">
                    <div class="col-12">
                      <div class="mb-1">
                        <label class="form-label" for="mobileNo"> <span class="required">*</span> Issue Date </label>
                        <input
                            class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                            tabindex="1"
                            type="date"
                            placeholder=""
                            v-model="formData.payslip_issue_date"
                        >
                      </div>
                    </div>

                    <div class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
                      <label class="form-label" for="mobileNo"> <span class="required">*</span> Pay Issue </label>
                      <input type="checkbox" v-model="formData.is_payslip" class="form-check-input mx-1">
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
                      <label class="form-label" for="email">Sent Email? </label>
                      <input type="checkbox" v-model="formData.is_email" class="form-check-input mx-1">
                    </div>
                  </div>
                  <div class="d-flex justify-content-start justify-content-sm-center px-2 gap-1 flex-wrap">
                    <hr class="hr-full-width ">
                    <button :disabled="loading" @click="handleSubmit()"
                            class="btn btn-primary">
                      Save
                    </button>
                  </div>
                 </div>
            </div>
        </div>
        <Loader v-if="loader"/>

    </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import { inject, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import {useRoute, useRouter} from 'vue-router';
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";

const props = defineProps({
  payrollStatementData: {
    default: {}
  }
});
const emit = defineEmits(['submitted']);
const $store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const loader = ref(false);
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const route = useRoute();
const router = useRouter();

let formData = ref({
  company_id: $route.params.companyId,
  payroll_statement_id: props.payrollStatementData && props.payrollStatementData.id,
  is_payslip: false,
  is_email: false,
  payslip_issue_date: ''
})

const {
  updatePayrollStatementPayslipIssue
} = handleHrPayroll()

const onClickClose = () => {
    $store.state.isModalOpenThree = false;
}

function getQuery() {
  return `?company_id=${$route.params.companyId}`;
}

const handleSubmit = () => {
  let payslipData = {}
  payslipData.payroll_statement_id = formData.value.payroll_statement_id;
  payslipData.is_payslip = formData.value.is_payslip;
  payslipData.is_email = formData.value.is_email;
  payslipData.payslip_issue_date = formData.value.payslip_issue_date;

  updatePayrollStatementPayslipIssue(payslipData, getQuery())
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
        showSuccess(res.message)
        onClickClose()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
    loader.value = false
  })
}

onMounted(() => {
   formData.value.payslip_issue_date = props.payrollStatementData.payslip_issue_date;
   formData.value.is_payslip =  props.payrollStatementData.is_payslip === 1;
   formData.value.is_email =  props.payrollStatementData.is_email === 1;
})
</script>
